var _style, _g, _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle2, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBizversityLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 958.3 216.1",
    style: {
      enableBackground: "new 0 0 958.3 216.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#44487B;}\n\t.st1{fill:#AD227A;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:url(#SVGID_2_);}\n\t.st4{fill:url(#SVGID_3_);}\n\t.st5{fill:url(#SVGID_4_);}\n\t.st6{fill:url(#SVGID_5_);}\n\t.st7{fill:url(#SVGID_6_);}\n\t.st8{fill:url(#SVGID_7_);}\n\t.st9{fill:url(#SVGID_8_);}\n\t.st10{fill:url(#SVGID_9_);}\n\t.st11{fill:url(#SVGID_10_);}\n\t.st12{fill:url(#SVGID_11_);}\n\t.st13{fill:url(#SVGID_12_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.4,198.8l72.8-72.8c10.5-10.5,10.5-27.4,0-37.9c-10.5-10.5-27.4-10.5-37.9,0l-72.8,72.8 C5,171.4,5,188.3,15.5,198.8C25.9,209.3,42.9,209.3,53.4,198.8L53.4,198.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.5,15.2C5,25.7,5,42.7,15.5,53.1L88.3,126c10.5,10.5,10.5,27.4,0,37.9l37.9-37.7c5.3-5.3,7.9-12.2,7.8-19 c0-6.9-2.6-13.8-7.8-19L53.4,15.2C42.9,4.8,25.9,4.8,15.5,15.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.9538,
    y1: 133.72,
    x2: 948.793,
    y2: 133.72
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#44487B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#4C3468"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5084,
    style: {
      stopColor: "#4E1C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6885,
    style: {
      stopColor: "#6B2061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AD227A"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M950,73.3c0.3-0.7,0.7-1.8,0.7-3.5c0-5.3-4.1-9.4-9.4-9.4c-2.9,0-6.8,1.1-8.8,6.1l-27.8,68L877,66.5 c-2-5-5.9-6.1-8.8-6.1c-5.3,0-9.4,4.1-9.4,9.4c0,1.7,0.4,2.8,0.7,3.5l35.4,84.3c-8.5,21.1-12.9,31.6-29.5,31.6 c-5,0-8.9,3.9-8.9,8.9c0,5,3.9,8.9,8.9,8.9c20.2,0,32.4-9.6,42.3-33.2l42.1-100.4L950,73.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.9538,
    y1: 36.0204,
    x2: 948.793,
    y2: 36.0204
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#44487B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#4C3468"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5084,
    style: {
      stopColor: "#4E1C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6885,
    style: {
      stopColor: "#6B2061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AD227A"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 774,
    cy: 36,
    r: 11.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.9538,
    y1: 113.1071,
    x2: 948.793,
    y2: 113.1071
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#44487B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#4C3468"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5084,
    style: {
      stopColor: "#4E1C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6885,
    style: {
      stopColor: "#6B2061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AD227A"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M393.5,145.8h-44L399.9,77c2.6-3.6,2.3-8.1-0.4-11.4c-0.4-0.5-0.8-1-1.3-1.4c-0.1-0.1-0.2-0.2-0.3-0.3 c-0.2-0.1-0.4-0.2-0.6-0.3c-0.7-0.5-1.5-0.8-2.3-1.1c-0.5-0.1-0.9-0.2-1.4-0.3c-0.4-0.1-0.7-0.2-1.1-0.2h-58.5 c-5,0-8.9,3.9-8.9,8.9c0,5,3.9,8.9,8.9,8.9h40.6l-50.7,69.2c-1.1,1.5-1.5,3.1-1.7,4.7c-0.1,0.4-0.2,0.8-0.2,1.3 c0,0.2,0.1,0.4,0.1,0.6c0,0.3,0.1,0.6,0.2,0.8c0.6,3.6,3.2,6.3,6.7,7.1c0.2,0.1,0.5,0.1,0.7,0.1c0.4,0.1,0.8,0.2,1.2,0.2h62.6 c5,0,9.2-4.1,9.2-9.2S398.6,145.8,393.5,145.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.9538,
    y1: 113.1067,
    x2: 948.793,
    y2: 113.1067
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#44487B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#4C3468"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5084,
    style: {
      stopColor: "#4E1C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6885,
    style: {
      stopColor: "#6B2061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AD227A"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M492.9,60.4c-2.9,0-6.8,1.1-8.8,6.1l-27.8,68l-27.8-67.9c-2-5-5.9-6.1-8.8-6.1c-5.3,0-9.4,4.1-9.4,9.4 c0,1.7,0.4,2.8,0.7,3.5l36.5,86.7l0,0.1c1.7,3.6,4.9,5.7,8.7,5.7c3.8,0,7-2.1,8.7-5.8l36.4-86.5l0.1-0.3c0.3-0.7,0.7-1.8,0.7-3.5 C502.3,64.5,498.2,60.4,492.9,60.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.9538,
    y1: 112.9999,
    x2: 948.793,
    y2: 112.9999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#44487B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#4C3468"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5084,
    style: {
      stopColor: "#4E1C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6885,
    style: {
      stopColor: "#6B2061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AD227A"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M552.6,59.1c-29.6,0-46.5,19.6-46.5,53.8c0,44.6,26.5,54,48.7,54c21.3,0,33-10.6,35.1-12.7 c1.5-1.5,3.1-3.4,3.1-6.7c0-4.8-3.9-8.7-8.7-8.7c-2.5,0-3.8,0.8-5.4,1.8c-5.9,4.4-12.5,8.7-24.1,8.7c-17.5,0-28.7-11.3-29.7-29.7 h59.8c11.1,0,11.1-10.1,11.1-16.2c0-4.8-0.8-17.2-8-27.7C580.4,64.6,568.5,59.1,552.6,59.1z M525.3,102.5 c2-16.7,11.6-25.9,27.3-25.9c15.9,0,24.1,8.5,24.8,25.9H525.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.9538,
    y1: 112.6797,
    x2: 948.793,
    y2: 112.6797
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#44487B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#4C3468"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5084,
    style: {
      stopColor: "#4E1C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6885,
    style: {
      stopColor: "#6B2061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AD227A"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M657.9,59.5c-11.2,0-20.9,4.1-27.2,11.1v-0.8c0-5.3-4.1-9.4-9.4-9.4c-5.3,0-9.4,4.1-9.4,9.4v86.7 c0,5.3,4.1,9.4,9.4,9.4c5.3,0,9.4-4.1,9.4-9.4v-47.8c0-19.6,9.9-30.8,27.2-30.8c5,0,9.2-4.1,9.2-9.2S663,59.5,657.9,59.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.9538,
    y1: 113.0004,
    x2: 948.793,
    y2: 113.0004
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#44487B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#4C3468"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5084,
    style: {
      stopColor: "#4E1C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6885,
    style: {
      stopColor: "#6B2061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AD227A"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M715.3,103.5c-11.8-4.1-22-7.6-22-15.8c0-8.5,9-10.3,16.5-10.3c10.7,0,16.4,3.3,21.5,8.2 c1.8,1.8,3.9,2.7,6.3,2.7c4.8,0,8.7-3.9,8.7-8.7c0-2.6-1.1-4.3-2-5.6c-7.2-9.5-19.4-14.7-34.5-14.7c-21.7,0-35.2,10.9-35.2,28.4 c0,21.4,19.2,27.9,34.7,33.1c11.5,3.9,21.5,7.3,21.5,15.2c0,11-12.6,12.6-20.1,12.6c-10.7,0-18.7-3.1-25.3-9.7 c-2.4-2.4-4.8-2.9-6.5-2.9c-4.8,0-8.7,3.9-8.7,8.7c0,2.3,0.8,3.9,2,5.6c6.4,8.1,20.8,16.3,38.5,16.3c24,0,38.8-11.8,38.8-30.7 C749.5,115.3,730.6,108.7,715.3,103.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.9538,
    y1: 113.1067,
    x2: 948.793,
    y2: 113.1067
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#44487B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#4C3468"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5084,
    style: {
      stopColor: "#4E1C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6885,
    style: {
      stopColor: "#6B2061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AD227A"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M774,60.4c-5.3,0-9.4,4.1-9.4,9.4v86.7c0,5.3,4.1,9.4,9.4,9.4c5.3,0,9.4-4.1,9.4-9.4V69.7 C783.3,64.5,779.2,60.4,774,60.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.9538,
    y1: 99.3294,
    x2: 948.793,
    y2: 99.3294
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#44487B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#4C3468"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5084,
    style: {
      stopColor: "#4E1C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6885,
    style: {
      stopColor: "#6B2061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AD227A"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M841.5,80c5,0,8.9-3.9,8.9-8.9c0-5-3.9-8.9-8.9-8.9h-11.4V42.2c0-5.2-4.2-9.4-9.4-9.4c-5,0-9.4,4.4-9.4,9.4 v19.9h-5.8c-5,0-8.9,3.9-8.9,8.9c0,5,3.9,8.9,8.9,8.9h5.8v56.4c0,17.9,11.2,29.4,28.6,29.4c5.1,0,9.2-3.9,9.2-8.9 c0-5-4-8.9-9.2-8.9c-6.3,0-9.9-4.2-9.9-11.6V80H841.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.9538,
    y1: 36.9522,
    x2: 948.793,
    y2: 36.9522
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#44487B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#4C3468"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5084,
    style: {
      stopColor: "#4E1C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6885,
    style: {
      stopColor: "#6B2061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AD227A"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 299.8,
    cy: 37,
    r: 11
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.9538,
    y1: 113.0006,
    x2: 948.793,
    y2: 113.0006
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#44487B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#4C3468"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5084,
    style: {
      stopColor: "#4E1C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6885,
    style: {
      stopColor: "#6B2061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AD227A"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M309.1,70.2v85.6c0,5.2-4.1,9.2-9.2,9.2c-5.2,0-9.2-4.1-9.2-9.2V70.2c0-5.2,4.1-9.2,9.2-9.2 C305,61,309.1,65,309.1,70.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.9538,
    y1: 90.9248,
    x2: 948.793,
    y2: 90.9248
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#44487B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2287,
    style: {
      stopColor: "#4C3468"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5084,
    style: {
      stopColor: "#4E1C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6885,
    style: {
      stopColor: "#6B2061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AD227A"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M250.9,85.8c8.8-5.9,14.4-16.3,14.4-27.8c0-26.1-16.3-40.4-45.8-40.4h-35.3c-5.8,0-10.5,4.7-10.5,10.5v125.5 c0,5.8,4.7,10.5,10.5,10.5h41.5c28.4,0,46-16.6,46-43.3C271.8,104.5,264.3,92.1,250.9,85.8z M194.8,78.6V37.5h24.5 c16.4,0,24.7,6.9,24.7,20.6c0,13.1-9,20.6-24.7,20.6H194.8z M250.5,120.9c0,15.3-8.6,23.5-24.9,23.5h-30.7V97.6h30.7 C241.4,97.6,250.5,106.1,250.5,120.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBizversityLogo);
export default __webpack_public_path__ + "static/media/bizversity-logo.c3355349cc6d5920a08b07b72ce0dc43.svg";
export { ForwardRef as ReactComponent };